export const EVENT_CATEGORY_DEFAULT = 'FOOTBALL';

export const EVENT_CATEGORY_OTHER = 'OTHER';

export const EVENT_CATEGORY_FALLBACK_LABEL = 'Иное';

export const EVENT_CATEGORY_OPTIONS = [
  { value: 'FOOTBALL', label: 'Футбол' },
  { value: 'HOCKEY', label: 'Хоккей' },
  { value: 'BASKETBALL', label: 'Баскетбол' },
  { value: 'TENNIS', label: 'Теннис' },
  { value: 'VOLLEYBALL', label: 'Волейбол' },
  { value: 'CYBERSPORT', label: 'Киберспорт' },
  { value: EVENT_CATEGORY_OTHER, label: EVENT_CATEGORY_FALLBACK_LABEL, hint: 'Своя категория' },
];

export const getEventCategoryLabel = (event) => {
  const customCategory = String(event?.customCategory || '').trim();
  if (customCategory) return customCategory;

  const category = String(event?.category || EVENT_CATEGORY_OTHER);
  return EVENT_CATEGORY_OPTIONS.find((option) => option.value === category)?.label || EVENT_CATEGORY_FALLBACK_LABEL;
};
